class Model {
    constructor(attrs = {}) {
      this.attrs = attrs;
    }
  
    getId() {
      return this.attrs.id;
    }
  
    setId(id) {
      this.attrs.id = id;
      return this;
    }
  
    clone() {
      return this;
    }
  }
  
  export default Model;